import { api } from "../client";
import { endpoints } from "../endpoints";
import { getSession } from "../../auth/session";

const pending = new Map();
export const normalizePresence = (values) => Array.from({ length: 5 }, (_, index) => {
  const value = Number(values?.[index]);
  return Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
});
/** @param {import("../generated/migration").components["schemas"]["VideoProgressInput"]} data */
export function reportProgress(id, data) {
  if (!Number.isInteger(data.content_index) || data.content_index < 1 || data.content_index > 5 ||
      !Number.isFinite(data.position) || !Number.isFinite(data.duration) || data.duration <= 0 || data.position < 0) {
    return Promise.reject(new Error("موقعیت یا مدت ویدیو معتبر نیست."));
  }
  const token = getSession()?.token;
  const key = token + ":" + id + ":" + data.content_index;
  let entry = pending.get(key);
  if (!entry) {
    entry = { next: null, running: false };
    pending.set(key, entry);
  }
  return new Promise((resolve, reject) => {
    if (entry.next) entry.next.waiters.push({ resolve, reject });
    else entry.next = { data, waiters: [{ resolve, reject }] };
    entry.next.data = data;
    if (entry.running) return;
    entry.running = true;
    const run = async () => {
      while (entry.next) {
        const item = entry.next; entry.next = null;
        try {
          if (token !== getSession()?.token) throw new Error("نشست تغییر کرده است.");
          const result = await api.request({ url: endpoints.classrooms.progress(id), method: "PATCH",
            data: { ...item.data, position: Math.min(item.data.position, item.data.duration) } });
          item.waiters.forEach(({ resolve }) => resolve(result.data));
        } catch (error) { item.waiters.forEach(({ reject }) => reject(error)); }
      }
      pending.delete(key);
    };
    run();
  });
}
